import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import { Autocomplete as JoyAutocomplete, AutocompleteProps, Typography } from "@mui/joy";

interface FormTextFieldProps {
    name: string;
    label: string;
    placeholder?: string;
    rules?: object;
    type?: string;
    helperText?: string;
    options: any[];
    size?: "sm" | "lg" | "md";
    helperType?: "tooltip" | undefined;
}

const Autocomplete: React.FC<FormTextFieldProps & AutocompleteProps<any, any, any, any>> = ({
    name,
    label,
    placeholder,
    rules = {},
    type = "text",
    helperText,
    options,
    size,
    helperType,
    ...props
}) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <FormControl error={!!fieldState.error} size={size || "md"} sx={{ flex: 1 }}>
                    <FormLabel>{label}</FormLabel>
                    {helperText && !fieldState.error && (
                        <Typography level="body-xs" sx={{ color: "text.secondary", mb: 1, mt: -0.7 }}>
                            {helperText}
                        </Typography>
                    )}
                    {fieldState.error && (
                        <Typography level="body-xs" color="danger" sx={{ mb: 1, mt: -0.7 }}>
                            {fieldState.error.message}
                        </Typography>
                    )}
                    <JoyAutocomplete
                        {...field}
                        onChange={(e: any, value: any) => field.onChange(value)}
                        placeholder={placeholder}
                        type={type}
                        {...props}
                        options={options}
                        slotProps={{
                            listbox: {
                                sx: {
                                    zIndex: 10001,
                                },
                            },
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

export default Autocomplete;
